import styled from 'styled-components';

export const FieldLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const OptionalLabel = styled.span`
  font-size: 11px;
  font-weight: 400;
  color: #adb5bd;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OptionLabel = styled.span`
  width: 100%;
  display: block;
`;

export const CompactFields = styled.div`
  .compact-field {
    padding: 5px 8px;

    input {
      font-size: 13px;
    }
  }
`;
